import { render, staticRenderFns } from "./SwatchBook.vue?vue&type=template&id=6cdc1ea1&scoped=true&"
import script from "./SwatchBook.vue?vue&type=script&lang=js&"
export * from "./SwatchBook.vue?vue&type=script&lang=js&"
import style0 from "./SwatchBook.vue?vue&type=style&index=0&id=6cdc1ea1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc1ea1",
  null
  
)

export default component.exports